import { createContext, useContext } from "react";

export function createSafeContext<T>(name: string) {
    const Context = createContext<T | null>(null);

    const useSafeContext = () => {
        const value = useContext(Context);
        if (!value) {
            throw new Error(`${name} must be used within its Provider`);
        }
        return value;
    };

    return [Context.Provider, useSafeContext] as const;
}
